import { S3_BUCKET_URL } from '@/constants';

import { ScreenName } from '../OwnAI/screens/Name';
import { ScreenPersonality } from '../OwnAI/screens/Personality';
import { ScreenSecurity } from '../OwnAI/screens/Security';
import { ScreenAboutLook } from '../OwnAIMan/screens/AboutLook';
import { ScreenCommunicate } from '../OwnAIMan/screens/Communicate';
import { ScreenEmail } from '../OwnAIMan/screens/Email';
import { ScreenInteraction } from '../OwnAIMan/screens/Interaction';
import { ScreenMajorTurnOff } from '../OwnAIMan/screens/MajorTurnOff';

import { AboutPersonalityScreen } from './screens/AboutPersonality';
import { BodyShapeScreen } from './screens/BodyShape';
import { BODY_SHAPE_OPTIONS } from './screens/BodyShape/BODY_SHAPE_OPTIONS';
import { FindAiScreen } from './screens/FindAi';
import { ObedienceScreen } from './screens/Obedience';
import { SettingUpProfileScreen } from './screens/SettingUpProfile';
import { WelcomeScreen } from './screens/Welcome';

import type { LayoutDataType } from './types';

const ASSETS_PATH = `${S3_BUCKET_URL}/layout-own-ai-man-tm`;
const CHARACTERS = ['thomas', 'maxim'];

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: CHARACTERS.map(
      (char) => `${ASSETS_PATH}/${char}/welcome/splash.jpg`,
    ),
  },
  find_ai: {
    component: FindAiScreen,
    images: CHARACTERS.map(
      (char) => `${ASSETS_PATH}/${char}/find_ai/splash.jpg`,
    ),
  },
  interactions: {
    component: ScreenInteraction,
    images: [],
  },
  communicate: {
    component: ScreenCommunicate,
    images: [],
  },
  obedience: {
    component: ObedienceScreen,
    images: CHARACTERS.map(
      (char) => `${ASSETS_PATH}/${char}/obedience/splash.jpg`,
    ),
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  major_turn_off: {
    component: ScreenMajorTurnOff,
    images: [],
  },
  about_personality: {
    component: AboutPersonalityScreen,
    images: CHARACTERS.map(
      (char) => `${ASSETS_PATH}/${char}/about_personality/splash.jpg`,
    ),
  },
  body_shape: {
    component: BodyShapeScreen,
    images: CHARACTERS.flatMap((char) =>
      BODY_SHAPE_OPTIONS.map(
        (option) => `${ASSETS_PATH}/${char}/body_shape/${option.id}.png`,
      ),
    ),
  },
  about_look: {
    component: ScreenAboutLook,
    images: [`${S3_BUCKET_URL}/layout-own-ai-man/bg-about-look.png`],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  setting_up_profile: {
    component: SettingUpProfileScreen,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export type LayoutStepKeyType = keyof typeof layoutSteps;

export const layoutDataDefault: LayoutDataType = {
  body_shape: null,
  interaction: null,
  communicate: null,
  obedience: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
  major_turn_off: null,
  name: '',
  email: '',
};
